export default {
    namespaced: true,
    state: {
        collections: [],
        supplierCollections: [],
        errors: {
            collections: {},
            createCollection: {},
            updateCollection: {},
            deleteCollection: {}
        }
    },
    getters: {
        getCollectionsByBrand: state => id => {
            if (!id) return state.collections
            return state.collections.filter(item => item.BrandID == id)
        },
        getCollectionBrandId: state => collectionId => {
            if (!collectionId) return ''
            return state.collections.find(
                item => item.CollectionID == collectionId
            ).BrandID
        },
        //values for supplier products page filter, default all
        supplierCollectionsValuesArr(state) {
            return state.supplierCollections.map(item => item.CollectionID)
        }
    },
    mutations: {
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        },
        SET_COLLECTIONS(state, payload) {
            state.collections = payload
        },
        SET_SUPPLIER_COLLECTIONS(state, payload) {
            state.supplierCollections = payload
        }
    },
    actions: {
        async getCollections({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'collections',
                val: ''
            })

            const url = '/supplier/collections'

            try {
                const resp = await this.$axios.get(url, {
                    params: data
                })

                if (data && data.existing) {
                    commit('SET_SUPPLIER_COLLECTIONS', resp.data)
                } else {
                    commit('SET_COLLECTIONS', resp.data)
                }
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'collections',
                        val: e.response.data
                    })
                }
            }
        },
        async createCollection({ commit, dispatch }, data) {
            commit('SET_ERRORS', {
                key: 'createCollection',
                val: ''
            })

            const url = '/supplier/collections'

            try {
                const resp = await this.$axios.post(url, data)
                return resp.data
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'createCollection',
                        val: e.response.data
                    })
                }

                throw e
            }
        },
        async updateCollection({ commit, dispatch }, payload) {
            commit('SET_ERRORS', {
                key: 'updateCollection',
                val: ''
            })

            const url = '/supplier/collections/' + payload.id

            try {
                const resp = await this.$axios.patch(url, payload.data)
                return resp.data
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'updateCollection',
                        val: e.response.data
                    })
                }

                throw e
            }
        },
        async deleteCollection({ commit, dispatch }, payload) {
            commit('SET_ERRORS', {
                key: 'deleteCollection',
                val: ''
            })

            const url = '/supplier/collections/' + payload.id

            try {
                const resp = await this.$axios.delete(url)
                return resp.data
            } catch (e) {
                console.log('Ошибка ' + e.message)
                if (e.response) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'deleteCollection',
                        val: e.response.data
                    })
                }

                throw e
            }
        }
    }
}
